// extracted by mini-css-extract-plugin
export default {"root":"Wjk42yT0Qo","root_coloredHeader":"TRePej7OAl","formWrapper":"wmaAwaWCV1","resultsWrapper":"VtITB_LC7R","resultsFooter":"hLsRSlmVPG","resultsFooter_bordered":"k_wNg2XDmH"};